/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * A MeasureIndex stores a cross-reference between measure values for a particular measure dataItem
 * and the row(s) where they occur.  It is implemented as an array so that there can be duplicates (ie: 10 occurrences of 1000 means 10 index entries)
 *
 **/
class MeasureIndex {
	/**
	 * @Constructor
	 * @param {Object} options
	 */
	constructor(measureDataItemUniqueId) {
		this.measureDataItemUniqueId = measureDataItemUniqueId;
		this.measureIndex=[];
	}

	/**
	 * Clear out the minMaxTable to collect new stats.
	 */
	reset() {
		this.measureIndex=[];
	}

	getValue(rowIdx) {
		return this.measureIndex[rowIdx] && this.measureIndex[rowIdx].v;
	}

	/**
	 * get an array of all entries in the measure index that have value +/- range/2
	 *
	 * TODO: So far, getEntries appears to perform well with no performance optimizations, however;
	 *		if performance becomes an issue, the array could be sorted and recent value to index could be stored to make retrieval very fast.
	 * @returns an array of value to row object that match the value +/- range/2
	 */
	getEntries(value, range) {
		const minValue = value - range/2;
		const maxValue = value + range/2;
		return this.measureIndex.filter((indexEntry) => {
			return indexEntry.v >= minValue && indexEntry.v <= maxValue;
		});
	}

	/**
	 * Add a single value/row cross-reference to the measureIndex.
	 * @param row - the row# from the queryResults.
	 * @param value - the measure value to incorporate
	 */
	add(row, value) {
		this.measureIndex.push({ v: value, r: row });
	}
}

export default MeasureIndex;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-crosshairs/src/js/MeasureIndex.js